'use client';

import LNImage from '@/components/complex/ln-image';
import Link from 'next/link';
import Typography from '@/components/primitives/typography';
import styles from './styles.module.scss';
import notFoundImage from '@/assets/images/404.png';
import Button from '@/components/primitives/button';
import { useBottomNavigation } from '@/components/complex/bottom-navigation';
import { useHeader } from '@/components/complex/header';

export default function NotFoundScreen() {
  useHeader({
    title: '여긴 아무것도 없어요',
  });
  useBottomNavigation(false);

  return (
    <div className={styles.container}>
      <LNImage
        source={notFoundImage.src}
        className={styles.image}
        alt="404 page"
        variant={''}
      />
      <div className={styles.ui}>
        <div className={styles.text}>
          <Typography size="h1" weight="bold">
            앗! 여기가 아닌가?
          </Typography>
          <Typography>
            주소를 잘못 입력하셨거나<br/>
            페이지가 삭제되었을 수 있어요
          </Typography>
        </div>
        <Link href="/" className={styles.link}>
          <Button>홈으로 돌아가기</Button>
        </Link>
      </div>
    </div>
  );
}
